import { configureMedia } from '@plickers/now-player-library'

// Where the shared library builds media delivery URLs from. Unset, it would be
// production on every build.
//
// This is its own module, imported first in index.js, because some modules build
// URLs while they are being imported (e.g. the fallback image and GIF URLs in
// prosemirror/utils/convertPMNodeToQuestionObject.js). A configureMedia call in
// index.js's body would only run after every import had been evaluated.
configureMedia({
  mediaDeliveryUrl: process.env.REACT_APP_ENV === 'production' ?
    'https://media.plickers.com/' :
    'https://media.plickers-dev.com/',
})
